import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

interface Props {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  style?: React.CSSProperties;
}

export const PageWithTitle = ({ children, title, style }: Props) => {
  return (
    <Box style={style} display="flex" flexDirection="column" p="1rem">
      {title && <Title variant="h5">{title}</Title>}
      <Container>{children}</Container>
    </Box>
  );
};

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: "0 0.5rem",
});

const Title = styled(Typography)({
  display: "flex",
  padding: "1rem 0",
  color: "white",
});
